// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"2cdf18bc","414":"de4abbff","453":"f7018916","586":"f3e8668e"}[chunkId] + ".chunk.js";
};